import { createSlice } from "@reduxjs/toolkit";

const initialImageAuthState = {
  verificationToken: null,
  imageToken: null,
  verificationTokenLoading: false,
  imageTokenLoading: false,
  error: null,
};

export const callTypes = {
  getVerificationToken: "getVerificationToken",
  getImageToken: "getImageToken",
};

export const imageAuthSlice = createSlice({
  name: "imageAuth",
  initialState: initialImageAuthState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.payload.error?.response?.data.message}`;
      switch (action.payload.callType) {
        case callTypes.getVerificationToken:
          state.verficationImageTokenLoading = false;
          break;
        case callTypes.getImageToken:
          state.imageTokenLoading = false;
          break;
        default:
          break;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      switch (action.payload.callType) {
        case callTypes.getVerificationToken:
          state.verificationTokenLoading = true;
          break;
        case callTypes.getImageToken:
          state.imageTokenLoading = true;
          break;
        default:
          break;
      }
    },
    verificationTokenFetched: (state, action) => {
      state.verificationToken = action.payload.verificationToken;
      state.verificationTokenLoading = false;
      state.error = null;
    },
    imageTokenFetched: (state, action) => {
      state.imageToken = action.payload.imageToken;
      state.imageTokenLoading = false;
      state.error = null;
    },
  },
});
